// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorBoundary_wrapper__pN2yq","heading":"ErrorBoundary_heading__Q3yWb","message":"ErrorBoundary_message__c3-l+","actions":"ErrorBoundary_actions__qAqPS"};